export const SEARCH_PAGE_ROOT_ANALYTICS_TAGS = [
  'platform:web',
  'page:search',
  'context:search-page',
] as const;

const SEARCH_SCOPE_TAG = {
  watches: 'scope:watches',
  straps: 'scope:straps',
  sunglasses: 'scope:sunglasses',
  stores: 'scope:stores',
} as const;

export type SearchScopeAnalyticsKey = keyof typeof SEARCH_SCOPE_TAG;

export const getSearchScopeAnalyticsTags = (
  scope: SearchScopeAnalyticsKey,
): string[] => [...SEARCH_PAGE_ROOT_ANALYTICS_TAGS, SEARCH_SCOPE_TAG[scope]];
